export default {
  assets: {
    asset: "Activo",
    assets: "Activos",
    assetLevel: "Nivel de Activo",
    assetModel: "Modelo",
    models: "Modelos",
    model: "Modelo",
    assetType: "Tipo",
    assetTypes: "Tipos",
    provider: "Proveedor",
    serialNo: "No. de Serie",
    tags: "Etiquetas",
    user: "usuario",
    itemManufacturer: "Fabricante",
    manufacturerName: "Nombre del Fabricante",
    manufacturerCode: "Código del Fabricante",
    associatedModels: "Modelos Asociados",
    associatedAssets: "Activos Asociados",
    projectName: "Nombre del Proyecto",
    commissioningDate: "Incorporación",
    constructionDate: "Construcción",
    assetId: "Id de Activo",
    AssetLocalization: "Localización del Activo ",
    identifier: "Identificador",
    createOrSelectTags: "seleccionar etiquetas",
    createNewAssetTag: "Crear nueva etiqueta de activo",
    errorAssetTag: "La etiqueta ya existe",
    noAssets: "No hay activos",
  },
  user: {
    name: "Usuario",
    plural: "Usuarios",
    columns: {
      id: "ID",
      userName: "Usuario",
      contact: "Contacto",
      myProfile: "Mi Perfil",
      contactList: "Lista de Contactos",
      tenant: "Organización",
      roles: "Roles",
      registrationDate: "Fecha de Registro",
      firstName: "Nombre",
      lastName: "Apellido",
      status: "estado",
      approved: "Aprobado",
      pending: "Pendiente",
      authenticationProvider: "Proveedor de Autenticación",
      email: "Correo Electrónico",
      language: "Idioma",
      userDescription: "Descripción del Usuario",
      lastLogin: "Último Inicio de Sesión",
      createdAt: "Creado el",
      modifiedAt: "Modificado el",
      isDeleted: "está eliminado",
      displayName: "Nombre a Mostrar",
      declined: "Rechazado",
    },
  },
  tenant: {
    name: "Organización",
    plural: "Inquilinos",
    myTenants: "Mis Inquilinos",
    phone: "Número de teléfono",
    zipCode: "Código Postal",
    country: "País",
    city: "Ciudad",
    streetAndNumber: "Calle y número",
    backToTenants: "Volver a Inquilinos",
    tenantIfo: "Información de la Organización",
    amountOfUsers: "Cantidad de Usuarios",
    amountOfAssets: "Cantidad de Activos",
    amountOfBillingAddress: "Cantidad de Direcciones de Facturación",
    amountOfContact: "Cantidad de Contactos",
    columns: {
      id: "ID",
      tenantIdentifier: "ID de Organización",
      tenantName: "Nombre de Organización",
      isDeleted: "está eliminado",
      createdAt: "Creado el",
      modifiedAt: "Modificado el",
      tenantRole: "Rol de Organización",
      tenantType: "Tipo de Organización",
    },
  },
  role: {
    name: "Rol",
    plural: "Roles",
    tenantRole: {
      "2ab640dd-39c0-4dc5-9a3f-1919f8efd4d0": "Operador de Planta",
      "6413f36a-0dd6-42a5-a3ac-a99f4539f48e": "Servicio de Rescate",
      "f8aa95db-158e-4a9e-8a0f-b5dcbcc5b1b7": "Operador de Plataforma",
      "8c5e7fda-e8bf-4a96-9a85-a6e23a8cd635": "Empresa de Servicios",
    },
    columns: {
      id: "ID",
      name: "Nombre",
      description: "Descripción",
      isDefaultRole: "es rol predeterminado",
      createdAt: "Creado el",
      modifiedAt: "Modificado el",
      isDeleted: "está eliminado",
    },
  },
};
